export const defaultLocale = 'en';
export const localeISOMapping = {
  en: 'en-US',
  fr: 'fr-FR',
};
